import { useState } from "react";
import { FaPaperPlane, FaSpinner } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getMenuPermissions } from "../utils/auth";

import "./ManageAdmins.css";

const API_URL = process.env.REACT_APP_API_URL;

function SendEmail() {

    // Mirrors require_menu_permission("send_email") on the backend.
    const perms = getMenuPermissions("send_email");

    const [form, setForm] = useState({ to_email: "", subject: "", body: "" });

    const [isSending, setIsSending] = useState(false);

    const handleChange = (e) => {

        setForm({ ...form, [e.target.name]: e.target.value });

    };

    const handleSend = async (e) => {

        e.preventDefault();

        if (!form.to_email || !form.subject || !form.body) {

            toast.warn("Recipient email, subject, and body are all required.");
            return;

        }

        setIsSending(true);

        try {

            const res = await fetch(`${API_URL}/portal/send-email`, {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify(form)

            });

            const data = await res.json();

            if (res.ok && data.status) {

                toast.success(data.message);

                setForm({ to_email: "", subject: "", body: "" });

            } else {

                toast.error(data.message || data.detail || "Failed to send email.");

            }

        } catch (err) {

            console.error("Failed to send email:", err);

            toast.error("Something went wrong while sending.");

        } finally {

            setIsSending(false);

        }

    };

    return (

        <div className="page">

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
            />

            <div className="page-header">

                <div>
                    <h2>Send Email</h2>
                    <p className="page-subtitle">
                        Send an ad-hoc email to any address, using the SMTP settings configured
                        under Email Configuration.
                    </p>
                </div>

            </div>

            <div className="inline-form-container">

                <form onSubmit={handleSend}>

                    <div className="inline-form-grid">

                        <input
                            name="to_email"
                            type="email"
                            placeholder="Recipient email"
                            value={form.to_email}
                            onChange={handleChange}
                            disabled={isSending}
                            className="full-width"
                        />

                        <input
                            name="subject"
                            placeholder="Subject"
                            value={form.subject}
                            onChange={handleChange}
                            disabled={isSending}
                            className="full-width"
                        />

                        <textarea
                            name="body"
                            placeholder="Email body"
                            value={form.body}
                            onChange={handleChange}
                            disabled={isSending}
                            className="full-width"
                            rows={8}
                        />

                    </div>

                    <div className="inline-form-actions">

                        {perms.add ? (

                        <button type="submit" className="save-btn" disabled={isSending}>
                            {isSending ? <><FaSpinner className="spin" /> Sending...</> : <><FaPaperPlane /> Send Email</>}
                        </button>

                        ) : (

                        <p style={{ color: "#6b7280", fontSize: "13px" }}>
                            You don't have permission to send emails. Ask a SuperAdmin to grant it under Role Permissions.
                        </p>

                        )}

                    </div>

                </form>

            </div>

        </div>

    );

}

export default SendEmail;
